export default __webpack_public_path__ + "static/media/pending-big.18935628.svg";